import { Badge } from '@/components/base/badge'
import { Field, Label } from '@/components/base/fieldset'
import { Input } from '@/components/base/input'
import { Select } from '@/components/base/select'
import { StepActionsContext } from '@/helpers/useTestDefinition'
import { Handle, Position, type Node, type NodeProps } from '@xyflow/react'
import { useContext } from 'react'

type RcdNode = Node<{ name: string, steppable: { breakerCount: number, phaseAngle: number, tripCurrent: number } }, 'rcd'>

export const RcdNode = ({ id, data }: NodeProps<RcdNode>) => {
  const { changeStep } = useContext(StepActionsContext)

  return (
    <div>
      <div className="text-white border border-zinc-500 rounded-lg p-4 bg-zinc-800/75 w-100">
        <div className="grid grid-cols-1 gap-2 items-center justify-around h-full">
          <div className="text-center"><Badge color="cyan">RCD</Badge></div>
          <Field>
            <Label>Name</Label>
            <Input value={ data.name } onChange={ e => changeStep(id, { name: e.target.value }) } />
          </Field>
          <Field>
            <Label>Breaker count</Label>
            <Select value={ data.steppable.breakerCount } onChange={ e => changeStep(id, { steppable: { breakerCount: parseInt(e.target.value) } }) }>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
            </Select>
          </Field>
          <Field>
            <Label>Phase angle</Label>
            <Select value={ data.steppable.phaseAngle } onChange={ e => changeStep(id, { steppable: { phaseAngle: parseInt(e.target.value) } }) }>
              <option value="0">0°</option>
              <option value="180">180°</option>
            </Select>
          </Field>
          <Field>
            <Label>Trip current</Label>
            <Select value={ data.steppable.tripCurrent } onChange={ e => changeStep(id, { steppable: { tripCurrent: parseInt(e.target.value) } }) }>
              <option value="15">15mA</option>
              <option value="30">30mA</option>
              <option value="150">150mA</option>
            </Select>
          </Field>
        </div>
      </div>
      <Handle position={ Position.Top } type="source" />
      <Handle position={ Position.Bottom } type="target" />
    </div>
  )
}
